import { createFileRoute } from '@tanstack/react-router';

import { NewOrganizationPage } from '../modules/organizations/ui/pages/NewOrganizationPage';

export const Route = createFileRoute('/_authenticated/super-admin/organizations/new')({
  component: NewOrganizationPage,
  staticData: {
    breadcrumb: ['Platform', 'Organizations', 'New'],
  },
});
